var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/init.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import badgePlaceholder from "./assets/badge-placeholder.svg";
var REWARDS_ACHIEVEMENTS_ASSETS = {
  ACHIEVEMENT_BADGE_PLACEHOLDER: badgePlaceholder
};

// src/init.ts
var initModule = () => {
  setDefaultAssets(REWARDS_ACHIEVEMENTS_ASSETS);
};

// src/achievements.routes.tsx
import React11 from "react";
import {
  Route,
  useRouteMatch,
  Switch,
  Redirect
} from "@leagueplatform/routing";
import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";

// src/hooks/use-is-about-me-enabled.ts
import { useFeatureFlagQuery } from "@leagueplatform/user-profile-api";
var ENABLE_ABOUT_ME_WEB = "about_me_web";
var ENABLE_ABOUT_ME_BE = "about_me";
var useIsAboutMeEnabled = () => {
  const { isLoading: isWebLoading, data: isAboutMeWebEnabled } = useFeatureFlagQuery(ENABLE_ABOUT_ME_WEB);
  const { isLoading: isBeLoading, data: isAboutMeBeEnabled } = useFeatureFlagQuery(ENABLE_ABOUT_ME_BE);
  const isAboutMeEnabled = isAboutMeWebEnabled && isAboutMeBeEnabled;
  const isLoading = isWebLoading || isBeLoading;
  return {
    isLoading,
    isAboutMeEnabled
  };
};

// src/pages/achievements-landing-page/achievements-landing-page.page.tsx
import React10 from "react";
import { trackAnalyticsEvent as trackAnalyticsEvent4, EVENT_NAME as EVENT_NAME4 } from "@leagueplatform/analytics";

// src/components/user-achievements/user-achievements.component.tsx
import React8, { useState } from "react";
import { trackAnalyticsEvent as trackAnalyticsEvent3, EVENT_NAME as EVENT_NAME3 } from "@leagueplatform/analytics";
import { SkeletonBox } from "@leagueplatform/web-common-components";

// src/hooks/achievements-page.hook.ts
import { useQuery } from "react-query";
import {
  getUserAchievements,
  GET_USER_ACHIEVEMENTS_MESSAGE_TYPE
} from "@leagueplatform/rewards-api";
import { captureError } from "@leagueplatform/observability";

// src/hooks/use-is-achievements-enabled.hook.ts
import { useFeatureFlagQuery as useFeatureFlagQuery2 } from "@leagueplatform/user-profile-api";

// src/constants/feature-flag-names.constants.ts
var ACHIEVEMENTS_ENABLED = "achievements_enabled";

// src/hooks/use-is-achievements-enabled.hook.ts
var useIsAchievementsEnabled = () => {
  const { data: isFeatureFlagOn } = useFeatureFlagQuery2(ACHIEVEMENTS_ENABLED);
  return {
    isFeatureFlagOn
  };
};

// src/hooks/achievements-page.hook.ts
var useAchievementsPage = () => {
  var _a;
  const {
    data: userAchievementsData,
    status: userAchievementsStatus,
    error: userAchievementsError,
    isLoading: userAchievementsIsLoading,
    isRefetching: userAchievementsIsRefetching,
    refetch
  } = useQuery([GET_USER_ACHIEVEMENTS_MESSAGE_TYPE], getUserAchievements, {
    onError: (error) => {
      captureError(new Error(`Unable to get user's achievement: ${error}`));
    }
  });
  const { isFeatureFlagOn } = useIsAchievementsEnabled();
  return {
    isFeatureFlagOn,
    ready: !!(userAchievementsStatus === "success"),
    userAchievements: (_a = userAchievementsData == null ? void 0 : userAchievementsData.achievements_info) != null ? _a : [],
    error: userAchievementsError,
    userAchievementsIsLoading,
    refetch,
    userAchievementsIsRefetching
  };
};

// src/components/milestone-section/milestone-section.view.tsx
import React from "react";
import {
  Box,
  HeadingText,
  ParagraphText,
  Responsive,
  StackLayout,
  queryHelpers,
  useMediaQuery
} from "@leagueplatform/genesis-core";
import { splitAtNewlines } from "@leagueplatform/web-common";
import { LightQuestionIcon, TooltipModal } from "@leagueplatform/ui-kit";
var MilestoneSection = ({
  title,
  description,
  children
}) => {
  const isAboveTablet = useMediaQuery(queryHelpers.up("tablet"));
  const formattedDescription = splitAtNewlines(description).map(
    (partDescription, index) => /* @__PURE__ */ React.createElement(Responsive, { up: "tablet" }, /* @__PURE__ */ React.createElement(
      ParagraphText,
      {
        key: `${description};part:${index}`,
        css: {
          typography: "$bodyOneSecondary",
          marginTop: "$threeQuarters",
          color: "$onSurfaceTextSubdued"
        }
      },
      partDescription
    ))
  );
  return /* @__PURE__ */ React.createElement(Box, { css: { marginTop: "$four", marginBottom: "$half" } }, /* @__PURE__ */ React.createElement(
    StackLayout,
    {
      orientation: isAboveTablet ? "vertical" : "horizontal",
      css: {
        marginBottom: "$two"
      }
    },
    /* @__PURE__ */ React.createElement(HeadingText, { size: "xl", level: "2", css: { display: "inline-block" } }, title),
    description && /* @__PURE__ */ React.createElement(React.Fragment, null, formattedDescription, /* @__PURE__ */ React.createElement(Responsive, { down: "tablet" }, /* @__PURE__ */ React.createElement(
      TooltipModal,
      {
        marginTop: "10px",
        marginLeft: "quarter",
        label: /* @__PURE__ */ React.createElement(LightQuestionIcon, null),
        content: description
      }
    )))
  ), /* @__PURE__ */ React.createElement(StackLayout, { orientation: "horizontal", css: { flexWrap: "wrap" } }, children));
};

// src/components/view-programs-library-placeholder/view-programs-library-placeholder.view.tsx
import React2 from "react";
import { Link } from "@leagueplatform/routing";
import { EVENT_NAME, trackAnalyticsEvent } from "@leagueplatform/analytics";
import {
  HeadingText as HeadingText2,
  StackLayout as StackLayout2,
  UtilityText,
  Button
} from "@leagueplatform/genesis-core";
var ViewProgramLibraryPlaceholder = ({
  title,
  description,
  cta
}) => {
  const sendViewProgramLibraryAnalytics = () => {
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      product_area: "rewards",
      sub_product_area: "achievements",
      screen_name: "achievements",
      detail: "view health campaign library",
      cta_text: `cta: ${cta == null ? void 0 : cta.title}`
    });
  };
  return /* @__PURE__ */ React2.createElement(
    StackLayout2,
    {
      orientation: "vertical",
      verticalAlignment: "center",
      horizontalAlignment: "center",
      css: {
        backgroundColor: "$surfaceBackgroundSecondary",
        borderWidth: "$thin",
        borderRadius: "$large",
        borderColor: "$interactiveBorderDisabled",
        padding: "$oneAndHalf"
      }
    },
    /* @__PURE__ */ React2.createElement(HeadingText2, { level: "2", size: "md", css: { marginBottom: "$half" } }, title),
    /* @__PURE__ */ React2.createElement(
      UtilityText,
      {
        css: {
          typography: "$bodyOneSecondary",
          textAlign: "center",
          marginBottom: "$one",
          color: "$onSurfaceTextSubdued"
        }
      },
      description
    ),
    /* @__PURE__ */ React2.createElement(Button, { as: Link, to: cta == null ? void 0 : cta.url, onClick: sendViewProgramLibraryAnalytics }, cta == null ? void 0 : cta.title)
  );
};

// src/components/badge-card/badge-card.view.tsx
import React5 from "react";
import {
  Card,
  HeadingText as HeadingText3,
  StackLayout as StackLayout3,
  TextAction,
  useClickableCard
} from "@leagueplatform/genesis-core";

// src/components/badge-image/badge-image.view.tsx
import React3 from "react";
import { handleStaticAsset } from "@leagueplatform/asset-config";
import { Icon, styled } from "@leagueplatform/genesis-core";
var StyledBadgeImage = styled(Icon);
var BadgeImage = ({
  imageUrl,
  isDisabled = true,
  css,
  label
}) => {
  const disabledBadgePlaceholder = handleStaticAsset(
    "ACHIEVEMENT_BADGE_PLACEHOLDER" /* ACHIEVEMENT_BADGE_PLACEHOLDER */
  );
  return imageUrl ? /* @__PURE__ */ React3.createElement(
    StyledBadgeImage,
    {
      icon: imageUrl,
      label,
      size: "$four",
      css: __spreadValues({
        opacity: isDisabled ? "20%" : "100%",
        filter: `saturate(${isDisabled ? 0 : 1})`
      }, css)
    }
  ) : /* @__PURE__ */ React3.createElement(
    StyledBadgeImage,
    {
      icon: disabledBadgePlaceholder,
      size: "$four",
      css: __spreadValues({}, css)
    }
  );
};

// src/components/earned-tag/earned-tag.view.tsx
import React4 from "react";
import { Box as Box2, UtilityText as UtilityText2 } from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
var EarnedTag = ({ completionAmount, isBadge }) => {
  const { formatMessage } = useIntl();
  if (completionAmount > 1) {
    return isBadge ? /* @__PURE__ */ React4.createElement(
      Box2,
      {
        css: {
          position: "absolute",
          top: 0,
          right: 0,
          maxHeight: "$two"
        }
      },
      /* @__PURE__ */ React4.createElement(
        UtilityText2,
        {
          as: "span",
          css: {
            typography: "$subtitleTwo",
            color: "$onSurfaceTextSubdued",
            letterSpacing: "0.6px",
            textTransform: "uppercase",
            backgroundColor: "$surfaceBackgroundSecondary",
            borderRadius: "$large",
            borderColor: "$interactiveBorderDisabled",
            paddingX: "$one",
            paddingY: "$half"
          }
        },
        formatMessage(
          { id: "EARNED_X_TIMES" },
          { amount: completionAmount }
        )
      )
    ) : /* @__PURE__ */ React4.createElement(
      UtilityText2,
      {
        as: "span",
        css: {
          backgroundColor: "$surfaceBackgroundSecondary",
          borderRadius: "$large",
          borderColor: "$interactiveBorderDisabled",
          color: "$onSurfaceTextSubdued",
          paddingX: "$one",
          paddingY: "$half",
          letterSpacing: "-0.2px"
        }
      },
      " ",
      formatMessage(
        { id: "COMPLETED_X_TIMES" },
        { amount: completionAmount }
      )
    );
  }
  return null;
};

// src/components/badge-card/badge-card.view.tsx
var BadgeCard = ({
  imageUrl,
  isDisabled,
  title,
  earnedStreak,
  onClick
}) => {
  const earnedBadgeRequirement = 2;
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard();
  return /* @__PURE__ */ React5.createElement(
    Card.Elevated,
    {
      css: {
        position: "relative",
        margin: "$threeQuarters",
        height: "136px",
        width: "384px"
      }
    },
    /* @__PURE__ */ React5.createElement(
      Card.ClickArea,
      {
        ref: clickAreaRef,
        onCardMouseUp,
        onCardMouseDown,
        css: {
          backgroundColor: "$surfaceBackgroundPrimary",
          padding: "$threeQuarters"
        }
      },
      /* @__PURE__ */ React5.createElement(StackLayout3, { orientation: "horizontal", verticalAlignment: "center" }, /* @__PURE__ */ React5.createElement(
        BadgeImage,
        {
          imageUrl,
          isDisabled,
          css: {
            margin: "$oneAndHalf"
          }
        }
      ), /* @__PURE__ */ React5.createElement(
        HeadingText3,
        {
          level: "4",
          size: "md",
          css: {
            color: isDisabled ? "$onSurfaceTextSubdued" : "$onSurfaceTextPrimary"
          }
        },
        /* @__PURE__ */ React5.createElement(
          TextAction,
          {
            as: "button",
            ref: primaryActionRef,
            css: {
              all: "inherit"
            },
            onClick
          },
          title
        )
      ), earnedStreak >= earnedBadgeRequirement && /* @__PURE__ */ React5.createElement(EarnedTag, { completionAmount: earnedStreak, isBadge: true }))
    )
  );
};

// src/components/achievements-details-modal/achievements-details-modal.tsx
import React7 from "react";
import { Link as Link2 } from "@leagueplatform/routing";
import { JOURNEY_ROUTES } from "@leagueplatform/health-journey-common";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import {
  trackAnalyticsEvent as trackAnalyticsEvent2,
  usePageViewAnalytics,
  EVENT_NAME as EVENT_NAME2
} from "@leagueplatform/analytics";
import {
  Button as Button2,
  Box as Box4,
  StackLayout as StackLayout4,
  HeadingText as HeadingText4,
  ParagraphText as ParagraphText2,
  Modal
} from "@leagueplatform/genesis-core";

// src/components/progress-bar/progress-bar.view.tsx
import React6 from "react";
import { Box as Box3, UtilityText as UtilityText3, keyframes } from "@leagueplatform/genesis-core";
var ProgressBar = ({
  isLoading,
  currentActivity,
  totalActivities,
  progressTitle
}) => {
  const activityPercent = currentActivity / totalActivities * 100;
  const stretch = keyframes({
    "0%": { width: 0 },
    "100%": { width: `${activityPercent}%` }
  });
  return /* @__PURE__ */ React6.createElement(Box3, null, /* @__PURE__ */ React6.createElement(
    UtilityText3,
    {
      css: {
        typography: "$bodyTwo",
        color: "$onSurfaceTextSubdued",
        marginTop: "$half",
        marginBottom: "$quarter",
        display: "block"
      }
    },
    progressTitle
  ), /* @__PURE__ */ React6.createElement(
    Box3,
    {
      css: {
        width: "100%",
        height: "$threeQuarters",
        borderRadius: "$medium",
        marginBottom: "$half",
        backgroundColor: "$successBackgroundSubdued",
        overflow: "hidden"
      }
    },
    !isLoading && /* @__PURE__ */ React6.createElement(
      Box3,
      {
        css: {
          height: "$threeQuarters",
          backgroundColor: "$decorativeBrandSecondaryDark",
          borderRadius: "$medium",
          transition: "width 1.5s ease",
          animation: `${stretch} 1.5s ease-in-out forwards`
        }
      }
    )
  ));
};

// src/components/achievements-details-modal/achievements-details-modal.tsx
var AchievementsDetailsModal = ({
  open,
  onModalChange,
  modalAchievement
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const { formatMessage, formatDate } = useIntl2();
  usePageViewAnalytics({
    product_area: "rewards",
    sub_product_area: "achievements",
    screen_name: "achievement detail",
    sub_detail: modalAchievement.name,
    achievement_id: modalAchievement.id
  });
  const DATE_FORMAT = {
    year: "numeric",
    day: "numeric",
    month: "short"
  };
  const sendSelectOptionAnalytics2 = (selectedOption) => {
    trackAnalyticsEvent2(EVENT_NAME2.BUTTON_CLICKED, {
      product_area: "rewards",
      sub_product_area: "achievements",
      screen_name: "achievement detail",
      detail: selectedOption,
      sub_detail: modalAchievement.name,
      achievement_id: modalAchievement.id,
      is_earned: modalAchievement.progress.criteria.is_completed ? modalAchievement.progress.criteria.is_completed : false
    });
  };
  return /* @__PURE__ */ React7.createElement(Modal.Root, { open, onOpenChange: onModalChange }, /* @__PURE__ */ React7.createElement(
    Modal.Content,
    {
      css: {
        ".GDS-modal": { maxWidth: 500 },
        ".GDS-modal-content": { padding: "$twoAndHalf", paddingTop: "$none" }
      }
    },
    /* @__PURE__ */ React7.createElement(
      StackLayout4,
      {
        "data-testid": "achievement-modal",
        orientation: "vertical",
        horizontalAlignment: "center",
        css: { textAlign: "center" }
      },
      /* @__PURE__ */ React7.createElement(
        BadgeImage,
        {
          imageUrl: (_a = modalAchievement == null ? void 0 : modalAchievement.image) == null ? void 0 : _a.large,
          isDisabled: modalAchievement.completions < 1,
          css: { margin: "$oneAndHalf" }
        }
      ),
      /* @__PURE__ */ React7.createElement(HeadingText4, { level: "3", size: "lg" }, modalAchievement.name),
      ((_c = (_b = modalAchievement == null ? void 0 : modalAchievement.progress) == null ? void 0 : _b.criteria) == null ? void 0 : _c.is_completed) && /* @__PURE__ */ React7.createElement(
        HeadingText4,
        {
          level: "4",
          size: "sm",
          css: { paddingTop: "$half", color: "$onSurfaceTextSubdued" }
        },
        formatMessage({ id: "EARNED" }),
        " ",
        formatDate(modalAchievement.last_completed_at, DATE_FORMAT)
      ),
      /* @__PURE__ */ React7.createElement(
        ParagraphText2,
        {
          css: {
            paddingTop: "$oneAndHalf",
            color: "$onSurfaceTextSubdued"
          }
        },
        ((_e = (_d = modalAchievement == null ? void 0 : modalAchievement.progress) == null ? void 0 : _d.criteria) == null ? void 0 : _e.is_completed) ? modalAchievement.description_earned : modalAchievement.description
      ),
      modalAchievement.completions > 1 && /* @__PURE__ */ React7.createElement(Box4, { css: { paddingTop: "$threeQuarters" } }, /* @__PURE__ */ React7.createElement(EarnedTag, { completionAmount: modalAchievement.completions })),
      modalAchievement.display_progress && /* @__PURE__ */ React7.createElement(
        Box4,
        {
          css: {
            width: "100%",
            paddingTop: "$quarter",
            textAlign: "left"
          }
        },
        /* @__PURE__ */ React7.createElement(
          ProgressBar,
          {
            progressTitle: (_f = modalAchievement == null ? void 0 : modalAchievement.progress) == null ? void 0 : _f.title,
            isLoading: false,
            currentActivity: (_h = (_g = modalAchievement == null ? void 0 : modalAchievement.progress) == null ? void 0 : _g.criteria) == null ? void 0 : _h.current,
            totalActivities: (_j = (_i = modalAchievement == null ? void 0 : modalAchievement.progress) == null ? void 0 : _i.criteria) == null ? void 0 : _j.threshold
          }
        )
      ),
      !((_l = (_k = modalAchievement == null ? void 0 : modalAchievement.progress) == null ? void 0 : _k.criteria) == null ? void 0 : _l.is_completed) && /* @__PURE__ */ React7.createElement(
        Button2,
        {
          to: JOURNEY_ROUTES.journeyHome(),
          as: Link2,
          css: {
            textDecoration: "none",
            marginTop: "$two"
          },
          width: {
            "@initial": "hugContents",
            "@mobile": "fillContainer"
          },
          onClick: () => sendSelectOptionAnalytics2("back to journey")
        },
        formatMessage({ id: "GO_TO_JOURNEY" })
      )
    )
  ));
};

// src/components/user-achievements/user-achievements.component.tsx
var UserAchievements = ({ errorComponent }) => {
  const { userAchievements, error, userAchievementsIsLoading } = useAchievementsPage();
  const [showAchievementDetailsModal, setShowAchievementDetailsModal] = useState(false);
  const [modalAchievement, setModalAchievement] = useState();
  const badgeAnalytics = (badgeName, achievementId) => {
    trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, {
      product_area: "rewards",
      sub_product_area: "achievements",
      screen_name: "achievements",
      detail: "view achievement",
      sub_detail: badgeName,
      achievement_id: achievementId
    });
  };
  if (error) {
    return errorComponent;
  }
  if (userAchievementsIsLoading) {
    return /* @__PURE__ */ React8.createElement(SkeletonBox, { "data-testid": "loading-skeleton", width: "100%", height: "250px" });
  }
  return /* @__PURE__ */ React8.createElement(React8.Fragment, null, userAchievements.map(
    ({ category_title, tooltip, completed, in_progress, empty }) => {
      const allCompletedAndInProgressAchievementsInCategory = [
        ...completed || [],
        ...in_progress || []
      ];
      return /* @__PURE__ */ React8.createElement(
        MilestoneSection,
        {
          title: category_title,
          description: tooltip.description,
          key: category_title
        },
        allCompletedAndInProgressAchievementsInCategory.length > 0 ? /* @__PURE__ */ React8.createElement(React8.Fragment, null, allCompletedAndInProgressAchievementsInCategory.map(
          (achievement) => {
            var _a;
            return /* @__PURE__ */ React8.createElement(
              BadgeCard,
              {
                imageUrl: (_a = achievement.image) == null ? void 0 : _a.large,
                isDisabled: achievement.completions <= 0,
                title: achievement.name,
                key: achievement.id,
                earnedStreak: achievement.completions,
                onClick: () => {
                  setModalAchievement(achievement);
                  setShowAchievementDetailsModal(true);
                  badgeAnalytics(achievement.name, achievement.id);
                }
              }
            );
          }
        )) : /* @__PURE__ */ React8.createElement(
          ViewProgramLibraryPlaceholder,
          {
            title: empty == null ? void 0 : empty.title,
            description: empty == null ? void 0 : empty.description,
            cta: empty == null ? void 0 : empty.cta
          }
        )
      );
    }
  ), showAchievementDetailsModal && modalAchievement && /* @__PURE__ */ React8.createElement(
    AchievementsDetailsModal,
    {
      onModalChange: () => setShowAchievementDetailsModal((previous) => !previous),
      modalAchievement,
      open: showAchievementDetailsModal
    }
  ));
};

// src/components/achievement-breadcrumbs/achievement-breadcrumbs.view.tsx
import React9 from "react";
import { Link as Link3 } from "@leagueplatform/routing";
import { JOURNEY_ROUTES as JOURNEY_ROUTES2 } from "@leagueplatform/health-journey-common";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import { BackButtonArrow } from "@leagueplatform/web-common-components";
import { StackLayout as StackLayout5, HeadingText as HeadingText5 } from "@leagueplatform/genesis-core";
var AchievementBreadcrumb = () => {
  const { formatMessage } = useIntl3();
  return /* @__PURE__ */ React9.createElement(
    StackLayout5,
    {
      orientation: {
        "@initial": "vertical",
        "@laptop": "horizontal",
        "@desktop": "horizontal"
      }
    },
    /* @__PURE__ */ React9.createElement(
      BackButtonArrow,
      {
        as: Link3,
        to: JOURNEY_ROUTES2.journeyHome(),
        fontSize: "heading3",
        color: "onSurface.text.primary",
        marginRight: "one",
        marginY: "quarter",
        onClick: null
      }
    ),
    /* @__PURE__ */ React9.createElement(HeadingText5, { level: "1", size: "xxl" }, formatMessage({ id: "ACHIEVEMENTS" }))
  );
};

// src/pages/achievements-landing-page/achievements-landing-page.page.tsx
import { ErrorState } from "@leagueplatform/web-common-components";
import { StackLayout as StackLayout6 } from "@leagueplatform/genesis-core";
var AchievementsLandingPage = () => {
  trackAnalyticsEvent4(EVENT_NAME4.SCREEN_LOADED, {
    product_area: "rewards",
    sub_product_area: "achievements",
    screen_name: "achievements"
  });
  return /* @__PURE__ */ React10.createElement(
    StackLayout6,
    {
      orientation: "vertical",
      css: {
        maxWidth: "1400px",
        marginX: "auto",
        paddingX: "$two",
        paddingY: "$three"
      }
    },
    /* @__PURE__ */ React10.createElement(AchievementBreadcrumb, null),
    /* @__PURE__ */ React10.createElement(UserAchievements, { errorComponent: /* @__PURE__ */ React10.createElement(ErrorState, { hideImage: true }) })
  );
};

// src/achievements.routes.tsx
var AchievementsRoutes = () => {
  const { path } = useRouteMatch();
  const { isAboutMeEnabled } = useIsAboutMeEnabled();
  return /* @__PURE__ */ React11.createElement(Switch, null, isAboutMeEnabled ? (
    // `/about-me?view=achievements` replaces the `/achievements` page when the about me module is enabled.
    /* @__PURE__ */ React11.createElement(
      Redirect,
      {
        exact: true,
        from: path,
        to: `${getModulePath(LEAGUE_MODULE_NAMES.aboutMe)}?view=achievements`,
        key: "achievements"
      }
    )
  ) : null, /* @__PURE__ */ React11.createElement(Route, { exact: true, path: `${path}`, component: AchievementsLandingPage }));
};

// src/components/recent-achievements/no-recent-achievements.view.tsx
import React12 from "react";
import { Link as RouterLink } from "@leagueplatform/routing";
import {
  HeadingText as HeadingText6,
  StackLayout as StackLayout7,
  TextAction as TextAction2,
  UtilityText as UtilityText4
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import { EVENT_NAME as EVENT_NAME5, trackAnalyticsEvent as trackAnalyticsEvent5 } from "@leagueplatform/analytics";
import { getModulePath as getModulePath2, LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES2 } from "@leagueplatform/core";
var NoRecentAchievements = () => {
  const { formatMessage } = useIntl4();
  const sendViewAchievementsPageAnalytics = () => {
    trackAnalyticsEvent5(EVENT_NAME5.BUTTON_CLICKED, {
      product_area: "rewards",
      sub_product_area: "achievements",
      screen_name: "health journey activities",
      detail: "view all achievements"
    });
  };
  return /* @__PURE__ */ React12.createElement(
    StackLayout7,
    {
      orientation: "vertical",
      horizontalAlignment: "center",
      verticalAlignment: "center",
      css: {
        backgroundColor: "$surfaceBackgroundSecondary",
        padding: "$oneAndHalf"
      },
      "data-testid": "no-recent-achievements-container"
    },
    /* @__PURE__ */ React12.createElement(
      HeadingText6,
      {
        level: "3",
        size: "xs",
        css: {
          marginBottom: "$half",
          letterSpacing: "-0.2px"
        }
      },
      formatMessage({ id: "NO_PROGRAMS" })
    ),
    /* @__PURE__ */ React12.createElement(
      UtilityText4,
      {
        css: {
          typography: "$bodyTwoSecondary",
          textAlign: "center",
          marginBottom: "$one",
          color: "$onSurfaceTextSubdued"
        }
      },
      formatMessage({ id: "NO_ACHIEVEMENTS_DESCRIPTION" })
    ),
    /* @__PURE__ */ React12.createElement(
      TextAction2,
      {
        as: RouterLink,
        to: getModulePath2(LEAGUE_MODULE_NAMES2.rewardsAchievements),
        onClick: sendViewAchievementsPageAnalytics,
        size: "medium"
      },
      formatMessage({ id: "VIEW_ALL_ACHIEVEMENTS" })
    )
  );
};

// src/components/recent-achievements/recent-achievements.view.tsx
import React13 from "react";
import { Link as RouterLink2 } from "@leagueplatform/routing";
import { EVENT_NAME as EVENT_NAME6, trackAnalyticsEvent as trackAnalyticsEvent6 } from "@leagueplatform/analytics";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import { SidebarCard } from "@leagueplatform/web-common-components";
import { getModulePath as getModulePath3, LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES3 } from "@leagueplatform/core";
import {
  HeadingText as HeadingText7,
  Box as Box5,
  StackLayout as StackLayout8,
  TextAction as TextAction3,
  useMediaQuery as useMediaQuery2,
  queryHelpers as queryHelpers2,
  Icon as Icon2,
  UtilityText as UtilityText5
} from "@leagueplatform/genesis-core";
var Heading = ({ children }) => /* @__PURE__ */ React13.createElement(
  HeadingText7,
  {
    level: "2",
    size: "md",
    css: { marginBottom: "$oneAndHalf", color: "$onSurfaceTextSubdued" }
  },
  children
);
var RecentAchievements = ({
  achievements
}) => {
  const { formatMessage } = useIntl5();
  const isAboveLaptop = useMediaQuery2(queryHelpers2.up("laptop"));
  const sendViewAllAchievementsAnalytics = () => {
    trackAnalyticsEvent6(EVENT_NAME6.BUTTON_CLICKED, {
      product_area: "rewards",
      sub_product_area: "achievements",
      screen_name: "health journey progress",
      detail: "view all achievements"
    });
  };
  return /* @__PURE__ */ React13.createElement(
    SidebarCard,
    {
      padding: "oneAndHalf",
      "data-testid": "recent-achievements-container"
    },
    /* @__PURE__ */ React13.createElement(Box5, null, /* @__PURE__ */ React13.createElement(Heading, null, formatMessage({ id: "ACHIEVEMENTS" })), achievements.length === 0 ? /* @__PURE__ */ React13.createElement(NoRecentAchievements, null) : /* @__PURE__ */ React13.createElement(StackLayout8, { orientation: "vertical" }, /* @__PURE__ */ React13.createElement(Box5, { css: { width: "100%" } }, /* @__PURE__ */ React13.createElement(
      StackLayout8,
      {
        horizontalAlignment: achievements.length === 3 ? "spaceBetween" : "start",
        orientation: isAboveLaptop ? "vertical" : "horizontal",
        as: "ul",
        css: { marginBottom: "$one" }
      },
      achievements.map((achievement) => /* @__PURE__ */ React13.createElement(
        StackLayout8,
        {
          as: "li",
          orientation: "horizontal",
          verticalAlignment: "center",
          css: {
            marginRight: "$two",
            marginBottom: "$one"
          },
          key: achievement.id
        },
        /* @__PURE__ */ React13.createElement(Icon2, { icon: achievement.image.large, size: "$twoAndHalf" }),
        /* @__PURE__ */ React13.createElement(
          UtilityText5,
          {
            css: {
              typography: "$caption",
              textAlign: "center",
              marginLeft: "$half"
            }
          },
          achievement.name
        )
      ))
    )), /* @__PURE__ */ React13.createElement(
      TextAction3,
      {
        as: RouterLink2,
        to: getModulePath3(LEAGUE_MODULE_NAMES3.rewardsAchievements),
        onClick: sendViewAllAchievementsAnalytics
      },
      formatMessage({ id: "VIEW_ALL" })
    )))
  );
};

// src/components/celebration-achievements-modal/celebration-achievement-modal.component.tsx
import React15, { useEffect } from "react";
import {
  StackLayout as StackLayout10,
  VisuallyHidden,
  Box as Box6,
  HeadingText as HeadingText8,
  ParagraphText as ParagraphText3,
  Button as Button3,
  Icon as Icon3
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
import { EVENT_NAME as EVENT_NAME7, trackAnalyticsEvent as trackAnalyticsEvent7 } from "@leagueplatform/analytics";
import { Badge, Carousel } from "@leagueplatform/web-common-components";
import { PointsIcon } from "@leagueplatform/rewards-common";

// src/hooks/use-achievements-updates.hook.ts
import { useState as useState2 } from "react";
import { useQuery as useQuery2, useQueryClient } from "react-query";
import { useFeatureFlagQuery as useFeatureFlagQuery3 } from "@leagueplatform/user-profile-api";
import {
  fetchAndSyncAchievementUpdates,
  FETCH_AND_SYNC_ACHIEVEMENTS_UPDATES_MESSAGE_TYPE
} from "@leagueplatform/rewards-api";
import { captureError as captureError2 } from "@leagueplatform/observability";

// src/utils/get-achievements-by-status.util.ts
function getAchievementsByStatus(achievementsData) {
  const inProgressAchievements = [];
  const completedAchievements = [];
  achievementsData.forEach((achievementInfo) => {
    var _a, _b;
    inProgressAchievements.push(...(_a = achievementInfo.in_progress) != null ? _a : []);
    completedAchievements.push(...(_b = achievementInfo.completed) != null ? _b : []);
  });
  return { inProgressAchievements, completedAchievements };
}

// src/hooks/use-achievements-updates.hook.ts
var useAchievementsUpdates = (shouldFetchAchievementUpdates) => {
  var _a;
  const queryClient = useQueryClient();
  const {
    data: achievementsUpdateData,
    status: achievementsUpdateStatus,
    refetch: refetchAchievements,
    isFetching,
    isLoading
  } = useQuery2(
    [FETCH_AND_SYNC_ACHIEVEMENTS_UPDATES_MESSAGE_TYPE],
    fetchAndSyncAchievementUpdates,
    {
      enabled: shouldFetchAchievementUpdates || false,
      staleTime: Infinity,
      onError: (error) => {
        captureError2(
          new Error(`Unable to fetch achievement updates: ${error}`)
        );
      }
    }
  );
  const [showCelebrationAchievementModal, toggleCelebrationAchievementModal] = useState2(false);
  const { data: isAchievementsFeatureFlagOn } = useFeatureFlagQuery3(ACHIEVEMENTS_ENABLED);
  const { inProgressAchievements, completedAchievements } = getAchievementsByStatus((_a = achievementsUpdateData == null ? void 0 : achievementsUpdateData.achievements_info) != null ? _a : []);
  return {
    clearAchievements: () => queryClient.removeQueries(
      FETCH_AND_SYNC_ACHIEVEMENTS_UPDATES_MESSAGE_TYPE
    ),
    isAchievementsFeatureFlagOn,
    isAchievementUpdatesReady: achievementsUpdateStatus === "success" && !isLoading && !isFetching,
    inProgressAchievements,
    completedAchievements,
    hasCompletedAchievements: !!(achievementsUpdateStatus === "success") && completedAchievements.length,
    toggleCelebrationAchievementModal,
    showCelebrationAchievementModal,
    refetchAchievements
  };
};

// src/components/celebration-achievements-modal/components/achievement-fullscreen-modal.view.tsx
import React14 from "react";
import { StackLayout as StackLayout9, Modal as Modal2 } from "@leagueplatform/genesis-core";
var AchievementFullscreenModal = ({
  open,
  onClose,
  children
}) => (
  // const { formatMessage } = useIntl();
  /* @__PURE__ */ React14.createElement(Modal2.Root, { open, onOpenChange: onClose }, /* @__PURE__ */ React14.createElement(
    Modal2.Content,
    {
      css: {
        ".GDS-modal": { minWidth: 345, minHeight: 345 },
        ".GDS-modal-content": { padding: "$twoAndHalf", paddingTop: "$none" },
        "@mobile": {
          ".GDS-modal": { minWidth: "100%", minHeight: "100%" }
        },
        "@laptop": {
          ".GDS-modal": { minWidth: "768px", minHeight: "768px" }
        },
        "@desktop": {
          ".GDS-modal": { minWidth: "100%", minHeight: "100%" }
        }
      }
    },
    /* @__PURE__ */ React14.createElement(
      StackLayout9,
      {
        horizontalAlignment: "center",
        verticalAlignment: "center",
        css: {
          width: "100%"
        }
      },
      children
    )
  ))
);

// src/components/celebration-achievements-modal/celebration-achievement-modal.component.tsx
var modalTitleId = "celebration-modal-title";
var sendSelectOptionAnalytics = (selectedOption, completedTotalAchievements) => {
  completedTotalAchievements.map(
    (achievement) => trackAnalyticsEvent7(EVENT_NAME7.BUTTON_CLICKED, {
      product_area: "rewards",
      sub_product_area: "achievements",
      screen_name: "achievement celebration",
      detail: selectedOption,
      sub_detail: achievement.name,
      achievement_id: achievement.id
    })
  );
};
var CelebrationAchievementsModal = ({
  open,
  onClose
}) => {
  const { formatMessage } = useIntl6();
  const { completedAchievements } = useAchievementsUpdates();
  useEffect(() => {
    completedAchievements.map(
      (achievement) => trackAnalyticsEvent7(EVENT_NAME7.SCREEN_LOADED, {
        product_area: "rewards",
        sub_product_area: "achievements",
        screen_name: "achievement celebration",
        sub_detail: achievement.name,
        achievement_id: achievement.id
      })
    );
  });
  return /* @__PURE__ */ React15.createElement(
    AchievementFullscreenModal,
    {
      open,
      onClose: () => {
        sendSelectOptionAnalytics("close", completedAchievements);
        onClose();
      },
      "aria-labelledby": modalTitleId
    },
    /* @__PURE__ */ React15.createElement(
      StackLayout10,
      {
        horizontalAlignment: "center",
        verticalAlignment: "center",
        css: { height: "100%" }
      },
      /* @__PURE__ */ React15.createElement(VisuallyHidden, { id: modalTitleId }, formatMessage({ id: "CONGRATS_COMPLETED" })),
      /* @__PURE__ */ React15.createElement(StackLayout10, { orientation: "horizontal", css: { maxWidth: "384px" } }, completedAchievements.length > 0 && /* @__PURE__ */ React15.createElement(
        Carousel,
        {
          sideArrows: true,
          showProgressDots: true,
          name: "celebration-achievements"
        },
        completedAchievements.map((achievement) => {
          var _a;
          return /* @__PURE__ */ React15.createElement(Box6, { key: achievement == null ? void 0 : achievement.name }, /* @__PURE__ */ React15.createElement(
            StackLayout10,
            {
              horizontalAlignment: "center",
              css: { width: "384px", textAlign: "center" }
            },
            /* @__PURE__ */ React15.createElement(
              HeadingText8,
              {
                level: "1",
                size: "xxl",
                css: { marginTop: "$one", marginBottom: "$half" }
              },
              achievement == null ? void 0 : achievement.celebration_title
            ),
            /* @__PURE__ */ React15.createElement(
              ParagraphText3,
              {
                css: {
                  textAlign: "center",
                  color: "$onSurfaceTextSubdued"
                },
                size: "sm"
              },
              achievement == null ? void 0 : achievement.celebration_subtitle
            ),
            /* @__PURE__ */ React15.createElement(
              Box6,
              {
                css: {
                  marginTop: "$oneAndHalf",
                  marginBottom: "$half",
                  "@desktop": {
                    marginTop: "$four",
                    marginBottom: "$one"
                  }
                }
              },
              /* @__PURE__ */ React15.createElement(Icon3, { icon: (_a = achievement == null ? void 0 : achievement.image) == null ? void 0 : _a.large, size: "216px" })
            ),
            /* @__PURE__ */ React15.createElement(
              ParagraphText3,
              {
                css: {
                  textAlign: "center",
                  color: "$onSurfaceTextSubdued"
                }
              },
              formatMessage({ id: "YOUVE_COMPLETED" })
            ),
            /* @__PURE__ */ React15.createElement(HeadingText8, { level: "2", size: "xl" }, achievement == null ? void 0 : achievement.name),
            (achievement == null ? void 0 : achievement.program_points) && /* @__PURE__ */ React15.createElement(
              StackLayout10,
              {
                horizontalAlignment: "center",
                css: { marginTop: "$oneAndHalf" }
              },
              /* @__PURE__ */ React15.createElement(
                ParagraphText3,
                {
                  size: "sm",
                  css: {
                    textAlign: "center",
                    color: "$onSurfaceTextSubdued"
                  }
                },
                formatMessage({ id: "YOUVE_EARNED_GRAND_TOTAL" })
              ),
              /* @__PURE__ */ React15.createElement(
                Badge,
                {
                  css: {
                    fontWeight: "$semibold",
                    fontSize: "$subtitleTwo",
                    marginTop: "$half",
                    backgroundColor: "$decorativeBrandSecondaryDefault"
                  }
                },
                /* @__PURE__ */ React15.createElement(PointsIcon, { value: achievement == null ? void 0 : achievement.program_points })
              )
            )
          ));
        })
      )),
      /* @__PURE__ */ React15.createElement(
        Button3,
        {
          onClick: () => {
            sendSelectOptionAnalytics(
              "view achievements",
              completedAchievements
            );
            onClose();
          },
          css: {
            marginTop: "$oneAndHalf",
            "@desktop": {
              marginTop: "$four"
            }
          },
          width: "hugContents"
        },
        formatMessage({ id: "VIEW_ACHIEVEMENTS" })
      )
    )
  );
};

// src/components/achievements-stats/achievement-stats.view.tsx
import React16 from "react";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import {
  Box as Box7,
  styled as styled2,
  HeadingText as HeadingText9,
  UtilityText as UtilityText6,
  StackLayout as StackLayout11,
  Icon as Icon4
} from "@leagueplatform/genesis-core";
import { SidebarCard as SidebarCard2 } from "@leagueplatform/web-common-components";
var StyledListContainer = styled2(Box7, {
  "ul > li:first-of-type": {
    img: {
      marginBottom: "minusQuarter"
    }
  }
});
var AchievementStats = ({
  completedAchievements
}) => {
  const { formatMessage } = useIntl7();
  if (completedAchievements.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React16.createElement(
    SidebarCard2,
    {
      padding: "oneAndHalf",
      paddingBottom: "one",
      "data-testid": "achievement-stats"
    },
    /* @__PURE__ */ React16.createElement(HeadingText9, { level: "2", size: "md", css: { color: "$onSurfaceTextSubdued" } }, formatMessage({ id: "ACTIVITY_PROGRESS" })),
    /* @__PURE__ */ React16.createElement(StyledListContainer, null, /* @__PURE__ */ React16.createElement(StackLayout11, { as: "ul", orientation: "vertical" }, completedAchievements.map((achievement) => /* @__PURE__ */ React16.createElement(StackLayout11, { as: "li", key: achievement.category_group }, /* @__PURE__ */ React16.createElement(StackLayout11, { orientation: "horizontal", verticalAlignment: "center" }, /* @__PURE__ */ React16.createElement(
      Icon4,
      {
        icon: achievement.image.large,
        size: "$twoAndHalf",
        css: { marginLeft: "$minusOne" }
      }
    ), /* @__PURE__ */ React16.createElement(UtilityText6, { as: "span", emphasis: "emphasized" }, achievement.cumulative_count_stat, " ", achievement.unit, " ", achievement.subtitle))))))
  );
};

// src/components/badge-progress/badge-progress.view.tsx
import React17 from "react";
import { StackLayout as StackLayout12, Box as Box8, HeadingText as HeadingText10 } from "@leagueplatform/genesis-core";
var BadgeProgress = ({
  contentUrl,
  title,
  isLoading,
  currentActivity,
  totalActivities,
  progressTitle
}) => /* @__PURE__ */ React17.createElement(StackLayout12, { orientation: "horizontal", verticalAlignment: "center" }, /* @__PURE__ */ React17.createElement(
  BadgeImage,
  {
    imageUrl: contentUrl,
    isDisabled: false,
    css: { margin: "$oneAndHalf" }
  }
), /* @__PURE__ */ React17.createElement(Box8, { css: { width: "210px" } }, /* @__PURE__ */ React17.createElement(HeadingText10, { level: "2", size: "sm" }, title), /* @__PURE__ */ React17.createElement(
  ProgressBar,
  {
    isLoading,
    currentActivity,
    totalActivities,
    progressTitle
  }
)));

// src/components/rewards-sidebar-card/rewards-sidebar-card.tsx
import React18 from "react";
import { useLocation } from "@leagueplatform/routing";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
import {
  trackAnalyticsEvent as trackAnalyticsEvent8,
  EVENT_NAME as EVENT_NAME8,
  SCREEN_NAMES,
  SUB_PRODUCT_AREA,
  PRODUCT_AREA
} from "@leagueplatform/analytics";
import { getModulePath as getModulePath4, LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES4 } from "@leagueplatform/core";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES3,
  SCREEN_NAMES as HEALTH_JOURNEY_SCREEN_NAMES
} from "@leagueplatform/health-journey-common";
import {
  SidebarCard as SidebarCard3,
  GenesisRouterLink
} from "@leagueplatform/web-common-components";
import {
  HeadingText as HeadingText11,
  ParagraphText as ParagraphText4,
  TextAction as TextAction4
} from "@leagueplatform/genesis-core";

// src/hooks/use-rewards-sidebar.hook.ts
import { useQuery as useQuery3 } from "react-query";
import {
  getUserLeaguePointsRewardsBalance,
  GET_USER_LEAGUE_POINTS_REWARDS_BALANCE_MESSAGE_TYPE
} from "@leagueplatform/rewards-api";
import { captureError as captureError3 } from "@leagueplatform/observability";
var useRewardsSidebar = () => {
  const { isLoading, isError, data } = useQuery3(
    [GET_USER_LEAGUE_POINTS_REWARDS_BALANCE_MESSAGE_TYPE],
    getUserLeaguePointsRewardsBalance,
    {
      onError: (error) => {
        captureError3(
          new Error(`Unable to fetch user's rewards points balance: ${error}`)
        );
      }
    }
  );
  return {
    currentTierRewards: data == null ? void 0 : data.current_tier,
    hasError: isError,
    nextTierRewards: data == null ? void 0 : data.next_tier,
    ready: !isLoading,
    userRewardPoints: data == null ? void 0 : data.league_points
  };
};

// src/components/rewards-sidebar-card/rewards-sidebar-card.tsx
function ErrorMessage() {
  const { formatMessage } = useIntl8();
  return /* @__PURE__ */ React18.createElement(
    ParagraphText4,
    {
      css: {
        typography: "$subtitleTwo",
        fontWeight: "normal",
        paddingRight: "$oneAndHalf",
        marginY: "$one"
      }
    },
    formatMessage(
      { id: "WERE_HAVING_TROUBLE" },
      {
        custCareLink: /* @__PURE__ */ React18.createElement(
          TextAction4,
          {
            href: `mailto:${formatMessage({ id: "HELP_EMAIL" })}`,
            size: "medium"
          },
          formatMessage({ id: "CONTACT_CUSTOMER_CARE" })
        )
      }
    )
  );
}
function useRedeemDescription() {
  var _a, _b, _c, _d;
  const { currentTierRewards, nextTierRewards, userRewardPoints } = useRewardsSidebar();
  const { formatMessage, formatNumber } = useIntl8();
  if ((currentTierRewards == null ? void 0 : currentTierRewards.league_points) > 0) {
    return formatMessage(
      { id: "REDEEMABLE" },
      {
        value: formatNumber(((_a = currentTierRewards == null ? void 0 : currentTierRewards.league_credit) == null ? void 0 : _a.F) || 0, {
          style: "currency",
          currencyDisplay: "narrowSymbol",
          currency: ((_b = currentTierRewards == null ? void 0 : currentTierRewards.league_credit) == null ? void 0 : _b.C) || "CAD",
          minimumFractionDigits: 0
        })
      }
    );
  }
  return formatMessage(
    { id: "REDEEM_NEXT_TIER_POINTS" },
    {
      points: formatNumber(
        ((nextTierRewards == null ? void 0 : nextTierRewards.league_points) || 0) - (userRewardPoints || 0),
        { style: "decimal" }
      ),
      value: formatNumber(((_c = nextTierRewards == null ? void 0 : nextTierRewards.league_credit) == null ? void 0 : _c.F) || 0, {
        style: "currency",
        currencyDisplay: "narrowSymbol",
        currency: ((_d = nextTierRewards == null ? void 0 : nextTierRewards.league_credit) == null ? void 0 : _d.C) || "CAD",
        minimumFractionDigits: 0
      })
    }
  );
}
function RewardsSidebarCard() {
  const { formatMessage, formatNumber } = useIntl8();
  const { pathname } = useLocation();
  const description = useRedeemDescription();
  const { hasError, ready, userRewardPoints } = useRewardsSidebar();
  if (!hasError && userRewardPoints === void 0) {
    return null;
  }
  return ready ? /* @__PURE__ */ React18.createElement(SidebarCard3, null, /* @__PURE__ */ React18.createElement(HeadingText11, { level: "1", size: "md", css: { color: "$onSurfaceTextSubdued" } }, formatMessage({ id: "POINTS_BALANCE" })), hasError ? /* @__PURE__ */ React18.createElement(ErrorMessage, null) : /* @__PURE__ */ React18.createElement(React18.Fragment, null, /* @__PURE__ */ React18.createElement(HeadingText11, { level: "3", size: "xxl", css: { marginY: "$quarter" } }, formatNumber(userRewardPoints, { style: "decimal" })), /* @__PURE__ */ React18.createElement(
    ParagraphText4,
    {
      css: {
        typography: "$subtitleTwo",
        color: "$onSurfaceTextSubdued",
        fontWeight: "normal",
        paddingRight: "$oneAndHalf",
        marginBottom: "$one"
      }
    },
    description
  )), /* @__PURE__ */ React18.createElement(
    GenesisRouterLink,
    {
      to: "/member/get-rewarded",
      onClick: () => trackAnalyticsEvent8(EVENT_NAME8.BUTTON_CLICKED, {
        product_area: PRODUCT_AREA.REWARDS,
        sub_product_area: SUB_PRODUCT_AREA.POINTS,
        screen_name: pathname === JOURNEY_ROUTES3.journeyHome() && HEALTH_JOURNEY_SCREEN_NAMES.ACTIVITY_TIMELINE || pathname === getModulePath4(LEAGUE_MODULE_NAMES4.healthProfile) && SCREEN_NAMES.HEALTH_PROFILE,
        detail: "view points info"
      })
    },
    formatMessage({ id: "VIEW_YOUR_REWARDS" })
  )) : null;
}

// src/hooks/use-set-complete-user-health-activity.hook.ts
import {
  completeUserHealthActivity,
  COMPLETE_USER_HEALTH_ACTIVITY_MESSAGE_TYPE
} from "@leagueplatform/health-journey-api";
import { FETCH_AND_SYNC_ACHIEVEMENTS_UPDATES_MESSAGE_TYPE as FETCH_AND_SYNC_ACHIEVEMENTS_UPDATES_MESSAGE_TYPE2 } from "@leagueplatform/rewards-api";
import { useMutation, useQueryClient as useQueryClient2 } from "react-query";
var useCompleteActivity = (userActivityId, toggleAchievementUpdates) => {
  const queryClient = useQueryClient2();
  return useMutation(() => completeUserHealthActivity(userActivityId), {
    onSuccess: (data) => {
      queryClient.invalidateQueries(
        FETCH_AND_SYNC_ACHIEVEMENTS_UPDATES_MESSAGE_TYPE2
      );
      queryClient.setQueryData(
        [COMPLETE_USER_HEALTH_ACTIVITY_MESSAGE_TYPE],
        data
      );
      toggleAchievementUpdates(!!(data == null ? void 0 : data.completion_screen));
    }
  });
};

// src/hooks/use-achievements-details.hook.ts
import { useState as useState3 } from "react";
import { useQuery as useQuery4 } from "react-query";
import { useFeatureFlagQuery as useFeatureFlagQuery4 } from "@leagueplatform/user-profile-api";
import {
  getRecentAchievements,
  GET_RECENT_ACHIEVEMENTS_MESSAGE_TYPE,
  getAchievementsStats,
  GET_ACHIEVEMENTS_STATS_MESSAGE_TYPE
} from "@leagueplatform/rewards-api";
import { captureError as captureError4 } from "@leagueplatform/observability";
var useAchievementsDetail = () => {
  var _a, _b;
  const [showActivityCompleteModal, toggleActivityCompleteModal] = useState3(false);
  const { data: userRecentAchievementsData } = useQuery4(
    [GET_RECENT_ACHIEVEMENTS_MESSAGE_TYPE],
    getRecentAchievements,
    {
      onError: (error) => {
        captureError4(
          new Error(`Unable to fetch user's recent achievements: ${error}`)
        );
      }
    }
  );
  const { data: userAchievementStatsData } = useQuery4(
    [GET_ACHIEVEMENTS_STATS_MESSAGE_TYPE],
    getAchievementsStats,
    {
      onError: (error) => {
        captureError4(
          new Error(`Unable to fetch user's achievements stats: ${error}`)
        );
      }
    }
  );
  return {
    isFeatureFlagOn: useFeatureFlagQuery4(ACHIEVEMENTS_ENABLED),
    showActivityCompleteModal,
    toggleActivityCompleteModal,
    completedAchievementStats: (_a = userAchievementStatsData == null ? void 0 : userAchievementStatsData.achievements_stats) != null ? _a : [],
    recentAchievements: (_b = userRecentAchievementsData == null ? void 0 : userRecentAchievementsData.recent_achievements) != null ? _b : []
  };
};

// src/index.tsx
initModule();
export {
  ACHIEVEMENTS_ENABLED,
  AchievementFullscreenModal,
  AchievementStats,
  AchievementsRoutes,
  BadgeImage,
  BadgeProgress,
  CelebrationAchievementsModal,
  NoRecentAchievements,
  ProgressBar,
  RecentAchievements,
  RewardsSidebarCard,
  UserAchievements,
  getAchievementsByStatus,
  useAchievementsDetail,
  useAchievementsPage,
  useAchievementsUpdates,
  useCompleteActivity,
  useIsAchievementsEnabled,
  useRewardsSidebar
};
//# sourceMappingURL=index.js.map